<template>


</template>

<script>

import axios from "axios";

export default {
  name: "InitTodo",
  components: {
    
  },
  data() {
    return {
      form: {
        title: '',
        startDate: '',
        endDate: '',
        status: 'draft',
        userId: 0,
        todoType: ''
      }
    }
  },
  methods: {
    createTodo(){
      this.form.title = this.getTitle()
      this.form.startDate = new Date()
      console.log("this.form:", this.form);
      this.request.post("/todo/common", this.form).then(res => {
        if (res.code === '200') {
          this.$router.push(res.data.todoUrl + res.data.id)
        }
      })
    },

    getTitle() {
      if (this.form.todoType === 'petty-cash') {return '零用金請款單'}
      if (this.form.todoType === 'req-pay') {return '請款單'}
      if (this.form.todoType === 'req-buy') {return '請購單'}
    }
  },
  mounted() {
    this.form.todoType = this.$route.params.jobType
    this.createTodo()
  }
}
</script>

<style scoped>



</style>
